import { c as _c } from "react/compiler-runtime";
import { FormLabel, Stack, TextField, Typography, FormControl, type SxProps } from '@mui/material';
import { useState } from 'react';
import type React from 'react';
import { HelpIcon } from '@/components/shared/helpIcon';
import type { FieldValidation } from './validation/fieldValidation';
import { InputErrorIcon } from './validation/inputErrorIcon';
export const FormTextField = t0 => {
  const $ = _c(51);
  const {
    size: t1,
    testId,
    title,
    helpText,
    alwaysShowHelp: t2,
    dataTestId,
    validation,
    placeholder,
    value,
    onChange,
    sx,
    disabled: t3,
    autoFocus: t4,
    multiline: t5,
    rows: t6,
    maxLength
  } = t0;
  const size = t1 === undefined ? "medium" : t1;
  const alwaysShowHelp = t2 === undefined ? false : t2;
  const disabled = t3 === undefined ? false : t3;
  const autoFocus = t4 === undefined ? false : t4;
  const multiline = t5 === undefined ? false : t5;
  const rows = t6 === undefined ? 1 : t6;
  const [touched, setTouched] = useState(false);
  let t7;
  if ($[0] !== touched || $[1] !== validation || $[2] !== value) {
    t7 = touched && (validation ? !validation.validateInput(value) : false);
    $[0] = touched;
    $[1] = validation;
    $[2] = value;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  const hasError = t7;
  let t8;
  if ($[4] !== sx) {
    t8 = {
      width: "100%",
      ...sx
    };
    $[4] = sx;
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  let t9;
  if ($[6] !== alwaysShowHelp || $[7] !== helpText || $[8] !== title) {
    t9 = title && <FormLabel><Stack direction="row" sx={{
        alignItems: "center",
        justifyContent: "space-between"
      }}><Typography variant="subtitle1">{title}</Typography>{helpText && <HelpIcon title={helpText} alwaysVisible={alwaysShowHelp} className="text-(--mui-palette-text-secondary)" />}</Stack></FormLabel>;
    $[6] = alwaysShowHelp;
    $[7] = helpText;
    $[8] = title;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = () => setTouched(true);
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  const t11 = hasError ? "4px" : "24px";
  let t12;
  if ($[11] !== t11) {
    t12 = {
      paddingRight: t11
    };
    $[11] = t11;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] !== multiline) {
    t13 = multiline && {
      "& .MuiOutlinedInput-input": {
        paddingLeft: "0px"
      }
    };
    $[13] = multiline;
    $[14] = t13;
  } else {
    t13 = $[14];
  }
  let t14;
  if ($[15] !== t12 || $[16] !== t13) {
    t14 = {
      "& .MuiInputBase-root": t12,
      ...t13
    };
    $[15] = t12;
    $[16] = t13;
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  let t15;
  if ($[18] !== dataTestId) {
    t15 = dataTestId ? {
      "data-testid": dataTestId
    } : {};
    $[18] = dataTestId;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  let t16;
  if ($[20] !== maxLength) {
    t16 = maxLength !== undefined ? {
      maxLength
    } : {};
    $[20] = maxLength;
    $[21] = t16;
  } else {
    t16 = $[21];
  }
  let t17;
  if ($[22] !== t15 || $[23] !== t16) {
    t17 = {
      ...t15,
      ...t16
    };
    $[22] = t15;
    $[23] = t16;
    $[24] = t17;
  } else {
    t17 = $[24];
  }
  let t18;
  if ($[25] !== hasError || $[26] !== validation || $[27] !== value) {
    t18 = hasError && <InputErrorIcon errorMessage={validation?.errorMessage(value)} />;
    $[25] = hasError;
    $[26] = validation;
    $[27] = value;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  let t19;
  if ($[29] !== t18) {
    t19 = {
      endAdornment: t18
    };
    $[29] = t18;
    $[30] = t19;
  } else {
    t19 = $[30];
  }
  let t20;
  if ($[31] !== t17 || $[32] !== t19) {
    t20 = {
      htmlInput: t17,
      input: t19
    };
    $[31] = t17;
    $[32] = t19;
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  let t21;
  if ($[34] !== autoFocus || $[35] !== disabled || $[36] !== hasError || $[37] !== multiline || $[38] !== onChange || $[39] !== placeholder || $[40] !== rows || $[41] !== size || $[42] !== t14 || $[43] !== t20 || $[44] !== testId || $[45] !== value) {
    t21 = <TextField multiline={multiline} rows={rows} size={size} autoFocus={autoFocus} data-testid={testId} onBlur={t10} error={hasError} sx={t14} slotProps={t20} placeholder={placeholder} disabled={disabled} value={value} onChange={onChange} />;
    $[34] = autoFocus;
    $[35] = disabled;
    $[36] = hasError;
    $[37] = multiline;
    $[38] = onChange;
    $[39] = placeholder;
    $[40] = rows;
    $[41] = size;
    $[42] = t14;
    $[43] = t20;
    $[44] = testId;
    $[45] = value;
    $[46] = t21;
  } else {
    t21 = $[46];
  }
  let t22;
  if ($[47] !== t21 || $[48] !== t8 || $[49] !== t9) {
    t22 = <FormControl className="group/help" sx={t8}>{t9}{t21}</FormControl>;
    $[47] = t21;
    $[48] = t8;
    $[49] = t9;
    $[50] = t22;
  } else {
    t22 = $[50];
  }
  return t22;
};